import { useTheme } from "../../Contexts/ThemeContext";
import { _size, _style, _theme } from "../../core/core";
import { Button } from "../button/button";

import MoonSvg from "../../assets/taiga-uikit/icons/moon.svg?react";
import SunSvg from "../../assets/taiga-uikit/icons/sun-1.svg?react";

export const ButtonTheme = ({ size = _size.M, style = _style.secondary }) => {
  const { theme, setTheme } = useTheme();
  return (
    <Button
      size={size}
      onClick={() =>
        setTheme(theme === _theme.light ? _theme.dark : _theme.light)
      }
      style={style}
    >
      {theme === _theme.dark ? <MoonSvg /> : <SunSvg />}
    </Button>
  );
};
